import { Component } from '@angular/core';
import { EnvService } from '@services/env.service';
import { TenantInfoService } from '@services/tenant-info.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  private static readonly TENANT_LEGACY = 'c0945b70-f0ab-4396-baf1-4645f44ee549';

  logoUrl: string = EnvService.assetsUrl('assets/img/invoice-dark-theme.png');

  showMigrationBanner: boolean;
  isLegacyMode: boolean = localStorage.getItem('invoicecon_tenant_mode') === 'legacy';
  migrationSwitchUrl: string = this.isLegacyMode
    ? `${window.location.origin}${window.location.pathname}?default-login`
    : `${window.location.origin}${window.location.pathname}?legacy-login`;

  constructor() {
    // Só exibe banner se houver um tenant diferente do legado disponível via API
    const cachedTenantInfo = TenantInfoService.getCached();
    const hasNonLegacyTenant = cachedTenantInfo?.tenantId != null
      && cachedTenantInfo.tenantId !== LoginComponent.TENANT_LEGACY;
    this.showMigrationBanner = ((environment as any).show_migration_banner ?? true) && hasNonLegacyTenant;

    let temaAplicacao = localStorage.getItem('temaAplicacao');
    if (temaAplicacao && temaAplicacao.length > 1) {
      this.logoUrl = EnvService.assetsUrl(`assets/img/invoice-${temaAplicacao}-theme.png`);
    }
  }
}
